export const tabs = {
  recurring: 'recurring',
  purchase: 'purchase',
};
